import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownItem from "react-bootstrap/DropdownItem";
import Icon from "../../../components/Icon";
import { copyToClipboard, getURLGridQueryParams } from "../../../utils";
import { FavoriteQuery, useFavoriteQueries } from "../../../hooks";
import useSearchModals, {
  SEARCH_MODALS_NAMES,
  SearchModalsNamesType
} from "../hooks/useSearchModals";
import SearchModals from "./modals/SearchModals";
import { determineSelectionsFromQP } from "../util";

const onCopyQuery = (query: string) => {
  const { searchQuery } = getURLGridQueryParams(query);
  copyToClipboard(searchQuery, "Keyword");
};

const isDisabled = (query: string) => {
  const { searchQuery } = getURLGridQueryParams(query);
  return !searchQuery;
};

interface Props {
  onClick: (params: { item: string }) => void;
}

const SearchFavorites = ({ onClick }: Props) => {
  const { data: { data: favorites } = {} } = useFavoriteQueries();
  const { modalName, modalOpened, closeModal, openModal } = useSearchModals();

  const [selectedFavourite, setSelectedFavourite] = useState<
    FavoriteQuery | undefined
  >(undefined);

  const {
    searchQuery: selectedFavouriteQuery,
    selections: selectedFavouriteSelections,
    filters: { location: selectedFavouriteLocation }
  } = getURLGridQueryParams(selectedFavourite?.content);

  const openModalWithFavorite = (
    name: SearchModalsNamesType,
    favorite: FavoriteQuery
  ) => {
    setSelectedFavourite(favorite);
    openModal(name);
  };

  return (
    <div className="search-favourites">
      <h5 className="search-favourites__list-title">
        <Icon name="favorite-added" /> Favorites
      </h5>
      {!favorites?.length ? (
        <p className="search-favourites__empty-message">
          No favorite queries saved.
        </p>
      ) : (
        <ul className="search-favourites__list">
          {favorites?.map(favorite => (
            <li key={favorite.id} className="search-favourites__list-item">
              <Button
                variant="link"
                onClick={() => onClick({ item: favorite.content.trim() })}
                className="favourite-link"
              >
                {favorite.name}
              </Button>
              <span className="search-favourites__menu">
                <Dropdown
                  id={`search-favourites__menu-dropdown-${favorite.id}`}
                >
                  <Dropdown.Toggle
                    variant="link"
                    className="btn--icon-only btn--no-hover"
                  >
                    <Icon name="dots-vertical" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    renderOnMount
                    className="dropdown-menu--light dropdown-menu--small"
                  >
                    <DropdownItem
                      onClick={() =>
                        openModalWithFavorite(
                          SEARCH_MODALS_NAMES.EDIT_FAVOURITE,
                          favorite
                        )
                      }
                    >
                      Edit
                    </DropdownItem>
                    <DropdownItem
                      disabled={isDisabled(favorite.content)}
                      title={
                        isDisabled(favorite.content)
                          ? "This favorite doesn't have any keywords."
                          : ""
                      }
                      onClick={() => onCopyQuery(favorite.content)}
                    >
                      Copy Keywords
                    </DropdownItem>
                    <DropdownItem
                      onClick={() =>
                        openModalWithFavorite(
                          SEARCH_MODALS_NAMES.DELETE_FAVOURITE,
                          favorite
                        )
                      }
                    >
                      Remove
                    </DropdownItem>
                    <DropdownItem
                      onClick={() =>
                        openModalWithFavorite(
                          SEARCH_MODALS_NAMES.SHARE_QUERY,
                          favorite
                        )
                      }
                    >
                      Share
                    </DropdownItem>
                  </Dropdown.Menu>
                </Dropdown>
              </span>
            </li>
          ))}
        </ul>
      )}
      {modalOpened && (
        <SearchModals
          name={modalName ?? ""}
          onClose={closeModal}
          favoriteQuery={selectedFavourite}
          searchValue={{
            q: selectedFavouriteQuery,
            selections: determineSelectionsFromQP(selectedFavouriteSelections),
            location: selectedFavouriteLocation
          }}
        />
      )}
    </div>
  );
};
export default SearchFavorites;
